import { Chart } from 'primereact/chart'

// locals
import './DoughnutPage.scss'
import { ChartItems } from 'types/DashboardType'
import Legend from '../../chart-components/legend/Legend'
import TotalNotification from '../../chart-components/TotalNotification/TotalNotification'

const DoughnutChartPage = (props: {
  colors: any
  labels: string[]
  icon: any
  items: ChartItems | undefined
  detailTitle: string
  totalNotification?: number
}) => {
  const totalNotification =
    props.items?.doughnutItems.total !== undefined ? props.items?.doughnutItems.total : props?.totalNotification || 0

  const chartData = {
    labels: props.labels,
    datasets: [
      totalNotification === 0
        ? {
            data: [100],
            backgroundColor: '#cecece',
            hoverBackgroundColor: '#cecece',
          }
        : {
            data: props.items?.doughnutItems.datasets,
            backgroundColor: props.colors,
            hoverBackgroundColor: props.colors,
          },
    ],
  }
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: props.items && props.items.doughnutItems.total === 0 ? false : true,
      },
    },
  }
  return (
    <div className="flex-grow-1">
      <TotalNotification totalNotificationCount={totalNotification} icon={props.icon} detailTitle={props.detailTitle} />

      {!!props.items && (
        <Chart id={props.detailTitle} type="doughnut" data={chartData} options={options} className="notify-chart" />
      )}

      <div className="notification-legend-container">
        {!!props.items &&
          props.items.doughnutItems.datasets.map((value: any, index: any) => (
            <Legend
              key={props.colors[index]}
              color={props.colors[index]}
              legend={props.labels[index]}
              value={{
                percent: Math.round((totalNotification === 0 ? 0 : (value || 0) / totalNotification) * 100),
                number: value || 0,
              }}
            />
          ))}
      </div>
    </div>
  )
}

export default DoughnutChartPage
